const mEditionBillingAcademyCharges = {
  mEditionBillingAcademyCharges: {
    alerts: {
      readCobrosExportar: {
        error: 'Un error ha ocurrido. Espera un momento y vuelve a intentarlo.',
        success: 'Listado de cobros descargado.'
      },

      readCobros: {
        error: 'La academia que busca con ese url no existe'
      }
    },

    buttonPrimary: 'Descargar CSV',

    buttonSecondary: {
      filterText: 'Filtros Avanzados'
    },

    files: {
      charges: 'cobros'
    },

    free: 'Gratis',

    table: {
      thConcept: 'Producto',
      thClient: 'Alumno',
      thDate: 'Fecha',
      thDiscount: 'Desc.',
      thMethod: 'Medio',
      thRecord: 'Ver',
      thToPay: 'A Pagar',
      thTotal: 'Total'
    },

    tooltip: {
      restart: 'Actualizar'
    }
  }
}

export default mEditionBillingAcademyCharges
